import { Injectable } from '@angular/core';

import { BetslipBetBuilderPick } from '../../../../../core/picks/betslip-bet-builder-pick';
import { IBetslip } from '../../../../bet-generation/models';
import { MinSelectionsBetbuilderError } from '../../../errors/general/min-selections-betbuilder-error';
import { IPureBetslipValidator } from './validators';

export const MINIMUM_BET_BUILDER_SELECTIONS = 2;

export const underMinimumBetBuilderSelections = (pick?: BetslipBetBuilderPick): boolean => {
    return !!pick?.sportcastOptions && pick.sportcastOptions.length < MINIMUM_BET_BUILDER_SELECTIONS;
};

@Injectable()
export class MinSelectionsBetbuilderValidator implements IPureBetslipValidator<MinSelectionsBetbuilderError> {
    validate(betslip: IBetslip): MinSelectionsBetbuilderError[] {
        const hasInvalidBetBuilderPicks = betslip.slips.some((slip) =>
            Object.values(slip.slipPicks).some((slipPick) => {
                const pick = slipPick.pick;

                return BetslipBetBuilderPick.isEntainUiBetBuilderPick(pick) && underMinimumBetBuilderSelections(pick);
            }),
        );

        return hasInvalidBetBuilderPicks ? [new MinSelectionsBetbuilderError()] : [];
    }
}
